export const WEEKS_BEFORE = 5;
export const WEEKS_AFTER = 5;
export const WEEK_WIDTH = 180;
export const SLIDE_MS = 280;
export const PAGE_SIZE = 5;
